import { CATEGORY_PAGE_CONTAINER_NAME } from "@faire/deprecated-retailer-visitor-shared/categories/createRequests/__internal__/CATEGORY_PAGE_CONTAINER_NAME";
import { QueryParameters as BrandSearchParameters } from "@faire/web-api--source/endpoints/www/api/v2/search/brands/get";

export const createBrandFirstSearchRequest = ({
  navigationPath,
  filterKeys,
  requestPageSize,
  oneIndexedPageNumber,
}: {
  navigationPath: string;
  filterKeys: string[];
  requestPageSize: number;
  oneIndexedPageNumber: number;
}): BrandSearchParameters => {
  return BrandSearchParameters.build({
    navigation_path: navigationPath,
    filter_keys: filterKeys,
    page_size: requestPageSize,
    page: oneIndexedPageNumber,
    container_name: CATEGORY_PAGE_CONTAINER_NAME,
  });
};
